export const GET_MY_REWARD_WIDGET_INFO_START = 'GET_MY_REWARD_WIDGET_INFO_START';

export const GET_MY_REWARD_WIDGET_INFO_SUCCESS = 'GET_MY_REWARD_WIDGET_INFO_SUCCESS';

export const GET_MY_REWARD_WIDGET_INFO_FAILED = 'GET_MY_REWARD_WIDGET_INFO_FAILED';
